
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import items from './items';
import { Permission } from '@/enums/Permission';
import { hasCustomerGroup, hasRole } from '@/util/helper';

interface NavbarItem {
  key: string;
  group: string;
  title?: string;
  icon: string;
  to?: string;
  can?: Permission | Permission[];
  canAny?: Permission | Permission[];
  items?: NavbarItem[];
  adminOrCustomerGroupOnly?: boolean;
}

@Component
export default class Navbar extends Vue {
  @Prop({ type: Boolean, required: true }) public drawer!: boolean;

  public navbarItems: any = items;

  public drawerVisible: boolean = true;

  get navbarItemsFiltered(): NavbarItem[] {
    return this.navbarItems.filter((item: NavbarItem) => {
      if (!item.adminOrCustomerGroupOnly) {
        return true;
      }

      return hasRole('admin') || hasCustomerGroup();
    });
  }

  public canAccessGroupItemMenu(items: any): boolean {
    const allGroupPermissions: Permission[] = [];

    for (const item of items) {
      if (!item.can && !item.canAny) {
        continue;
      }

      if (item.can) {
        allGroupPermissions.push(...(Array.isArray(item.can) ? item.can : [item.can]));
      }

      if (item.canAny) {
        allGroupPermissions.push(...(Array.isArray(item.canAny) ? item.canAny : [item.canAny]));
      }
    }

    return this.$canAny(allGroupPermissions);
  }

  @Watch('drawer')
  public onDrawerChange() {
    this.drawerVisible = this.drawer;
  }

  @Watch('drawerVisible')
  public onDrawerVisibleChange(val: boolean, oldVal: boolean) {
    if (val !== oldVal) {
      this.$emit('drawer', val);
    }
  }
}
